export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_CURRENT_USER_PROFILE = 'SET_CURRENT_USER_PROFILE'
export const SET_CURRENT_USER_AND_PROFILE = 'SET_CURRENT_USER_AND_PROFILE'
export const HOST_NAME = 'Host'
export const VOLONTEER_NAME = 'Volunteer'
